'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { trackOrder } from '@repo/ui/src/services/analytics/trackOrder';
import { removeQueryParam } from '@utils/removeQueryParam';
import OrderDetailContent, { OrderDetailProps } from '@views/OrderDetail/OrderDetailContent';
import React from 'react';

const OrderConfirmation = (props: OrderDetailProps) => {
  const { productGeo, query } = useCurrentUrl();

  React.useEffect(() => {
    trackOrder(props?.order, productGeo as 'US' | 'CA');
    removeQueryParam(query, 'token');
  }, []);

  return (
    <div className="tw-px-4">
      <div className="tw-max-w-4xl tw-mx-auto">
        <OrderDetailContent {...props} />
      </div>
    </div>
  );
};

export default OrderConfirmation;
